var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"FAQ"},[_c('SendyModal'),_vm._v(" "),_c('div',{staticClass:"portraitWrap"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgUrl1),expression:"imgUrl1"}],attrs:{"alt":"dwerve"}})]),_vm._v(" "),_c('div',{staticClass:"contents",domProps:{"innerHTML":_vm._s(_vm.marked(_vm.markdown))}}),_vm._v(" "),_c('Footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e842d45","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FAQ.vue
// module id = null
// module chunks = 